import React from 'react';
import styles from './FaqHelp.module.scss';
import { SFButton } from 'sfui';

export interface FaqHelpProps {
  url: string;
}

export const FaqHelp = ({
  url
}: FaqHelpProps): React.ReactElement<FaqHelpProps> => {
  const onClick = () => {
    window.open(url, '_blank');
  };

  return (
    <div className={styles.faqHelp}>
      <h2 className={styles.title}>Still need help?</h2>

      <SFButton className={styles.btn} size="large" onClick={onClick}>
        Get Custom Support
      </SFButton>
    </div>
  );
};
